import axios from 'axios'

export async function submitCredentialingForm(event) {
  event.preventDefault()

  const form = document.querySelector('#credentialingForm')

  // Convert form data into JSON for internal API
  const formData = new FormData(form)
  const formJson = {
    paymentFor: form.querySelector('[name="paymentAmount"]:checked').dataset.paymentFor,
    paymentAmount: parseFloat(formData.get('paymentAmount')) || 0,
    giftAmount: parseFloat(formData.get('giftAmount')) || 0,
    submittedOnBehalf: formData.get('submittedOnBehalf'),
  }

  try {
    // Submit the credentialing form data to the internal API
    const cmsApiResponse = await axios.post(
      '/webapi/cybersourceapi/submitcredentialingform',
      formJson
    )

    // Convert the internal API response into a form element that submits to CyberSource
    const cyberSourceForm = document.createElement('form')
    cyberSourceForm.action = cmsApiResponse.data.endpoint
    cyberSourceForm.method = 'post'
    Object.keys(cmsApiResponse.data.fields).forEach(key => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = key
      input.id = key
      input.value = cmsApiResponse.data.fields[key]
      cyberSourceForm.appendChild(input)
    })
    document.body.appendChild(cyberSourceForm)
    cyberSourceForm.submit()

    return { success: true }
  } catch {
    const errorMessageElement = form.querySelector('.form-submission-error')
    errorMessageElement.style.display = 'block'

    return { success: false, messages: ['An unexpected error occurred.'] }
  }
}